import { useMemo } from "react";
import React from "react";
import useImagePreviewProps from "domains/assets/hooks/useImagePreviewProps";
import { getIsAssetSkybox } from "domains/assets/utils/getIsType";
import { FileManagerVariant } from "domains/file-manager/components/FileManagerImage";
import FmCard, {
  FmCardProps,
} from "domains/file-manager/components/FileManagerV2/FmCard";

import { ImageProps } from "@chakra-ui/react";

interface CardContainerProps extends Omit<FmCardProps<"image">, "type"> {
  variant: FileManagerVariant;
}

export default React.memo(function CardContainer({
  file,
  isBlurred,
  children,
  imgProps,
  ...props
}: CardContainerProps) {
  const previewType =
    (file?.meta.metadata.type === "texture" && "texture") ||
    (getIsAssetSkybox(file?.meta) && "skybox") ||
    "image";
  const customImgProps = useImagePreviewProps(previewType);
  const newImgProps = useMemo(
    () =>
      ({
        ...imgProps,
        ...customImgProps,
      } satisfies ImageProps),
    [imgProps, customImgProps]
  );

  return (
    <FmCard
      type="image"
      isBlurred={isBlurred}
      file={file}
      {...props}
      imgProps={newImgProps}
    >
      {children}
    </FmCard>
  );
});
